import { OrganisationsTyp } from 'src/types/nya/common';

export const ORGANISATIONS_TYP_LABELS: Record<OrganisationsTyp, string> = {
  BOSTADSRÄTTSFÖRENING: 'Bostadsrättsförening',
  EKONOMISK_FÖRENING: 'Ekonomisk förening',
  IDEELL_FÖRENING: 'Ideell förening',
  AKTIEBOLAG: 'Aktiebolag',
  FÖRETAG: 'Företag',
  OKÄND: 'Okänd',
};

export function formatOrganisationsTyp(typ?: string | null): string {
  if (!typ) return '-';
  const uppercased = typ.toUpperCase() as OrganisationsTyp;
  return ORGANISATIONS_TYP_LABELS[uppercased] || typ;
}
